 
    <progress id="file" value={{value}} max="100"></progress><span class="grid-column-value padding-left-5">{{value }}%</span>